import { render, staticRenderFns } from "./RegMalariaList.vue?vue&type=template&id=68e281b9&scoped=true"
import script from "./RegMalariaList.vue?vue&type=script&lang=js"
export * from "./RegMalariaList.vue?vue&type=script&lang=js"
import style0 from "./RegMalariaList.vue?vue&type=style&index=0&id=68e281b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e281b9",
  null
  
)

export default component.exports